import { generateHTML, generateJSON, type Extensions } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import { TaskList } from '@tiptap/extension-task-list';
import { TaskItem } from '@tiptap/extension-task-item';

/* As mesmas extensões do NoteEditor e do ObservationEditor: o que elas não
   conhecem (script, onerror, style, iframe…) não sobrevive à ida e volta. */
const EXTENSOES: Extensions = [
    StarterKit,
    Image,
    TaskList,
    TaskItem.configure({ nested: true }),
];

const escapar = (texto: string) =>
    texto.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string));

/**
 * HTML de anotação pronto para `dangerouslySetInnerHTML` (04/11/2026).
 *
 * O backend guarda o que chega no body: quem chama a API direto grava
 * `<img src=x onerror=...>` e o script roda em quem abrir a tela (inclusive o
 * suporte da GB Code entrando na empresa). Passar pelo schema do TipTap deixa
 * só o que o editor produz. O DOMParser que o `generateJSON` usa é inerte:
 * nada executa nem carrega durante a limpeza.
 */
export const limparHtmlAnotacao = (html: string | null | undefined): string => {
    if (!html) return '';
    try {
        return generateHTML(generateJSON(html, EXTENSOES), EXTENSOES);
    } catch {
        return `<p>${escapar(html)}</p>`;
    }
};
